import script from "./NumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberInput.vue?vue&type=script&setup=true&lang=js"

import "./NumberInput.vue?vue&type=style&index=0&id=a71722c6&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a71722c6"]])

export default __exports__